import { render, staticRenderFns } from "./lk-tags.vue?vue&type=template&id=70be4f61&"
import script from "./lk-tags.vue?vue&type=script&lang=js&"
export * from "./lk-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-tags/lk-tags.vue
// module id = 1412
// module chunks = 0